import { render, staticRenderFns } from "./TodayMenu.vue?vue&type=template&id=51f4f562&scoped=true"
import script from "./TodayMenu.vue?vue&type=script&lang=js"
export * from "./TodayMenu.vue?vue&type=script&lang=js"
import style0 from "./TodayMenu.vue?vue&type=style&index=0&id=51f4f562&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51f4f562",
  null
  
)

export default component.exports